import React from 'react';
import { Order } from 'constants/interface';
import { Popover } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { MoreOutlined } from '@ant-design/icons';
import { OrderProposalStatusEnum } from 'constants/order';

import {
  PopoverContentWrapper,
  ActionButton,
  PopoverButton,
} from './style';

export enum ActionTypeEnum {
  COPY = 'COPY',
  SEND_TO_PRODUCTION = 'SEND_TO_PRODUCTION',
}

interface TableRowActionProps {
  order: Order
  index: number
  isActive: boolean
  onVisibleChange: (visibleIndex?: number) => void
  onActionSelected: (orderId: string, actionType: ActionTypeEnum) => void
}

const TableRowAction = ({
  order,
  index,
  isActive,
  onVisibleChange,
  onActionSelected,
}: TableRowActionProps): JSX.Element => {
  const internalVisibleChange = (
    isVisible: boolean,
  ): void => {
    onVisibleChange(isVisible ? index : undefined);
  };

  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();

  const onDetailsClick = () => {
    breadcrumbNavigator.push({
      label: `Pedido Nº ${order.seq}`,
      url: `${url}/${order.id}`,
    });
  };

  const onCopyClick = () => {
    onActionSelected(order.id, ActionTypeEnum.COPY);
    breadcrumbNavigator.push({
      label: 'Novo pedido',
      url: `${url}${ROUTES.orders.new.root}`,
    });
  };

  const onSendToProductionClick = () => {
    onActionSelected(order.id, ActionTypeEnum.SEND_TO_PRODUCTION);
    // breadcrumbNavigator.push({
    //   label: 'Novo pedido',
    //   url: `${url}${ROUTES.orders.new.root}`,
    // });
  };

  return (
    <Popover
      placement="left"
      trigger="click"
      visible={isActive}
      onVisibleChange={internalVisibleChange}
      content={(
        <PopoverContentWrapper>
          <ActionButton
            onClick={() => {
              internalVisibleChange(false);
              onDetailsClick();
            }}
          >
            Consultar
          </ActionButton>
          <ActionButton
            onClick={() => {
              internalVisibleChange(false);
              onCopyClick();
            }}
          >
            Copiar
          </ActionButton>
          {order.status === OrderProposalStatusEnum.CONFIRMED && (
            <ActionButton
              onClick={() => {
                internalVisibleChange(false);
                onSendToProductionClick();
              }}
            >
              Enviar para semeio
            </ActionButton>
          )}
        </PopoverContentWrapper>
      )}
    >
      <PopoverButton>
        <MoreOutlined />
      </PopoverButton>
    </Popover>
  );
};

export default TableRowAction;
